module.exports = __webpack_public_path__ + "img/DK66328511.9eda833e.png";